import React from 'react';
import { View, Pressable, StyleSheet, Text } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { useNavigation } from '@react-navigation/native';
import colors from '../util/colors';
import { mvs } from '../util/metrices';
import { useAuth } from '../context/AuthContext';

export const BAR_HEIGHT = mvs(75);

const BottomBar = ({ active = 'home' }) => {
  const navigation = useNavigation();
  const { isAuthenticated } = useAuth();

  const isHomeActive = active === 'home';
  const isCalendarActive = active === 'calendar';
  const isUserActive = active === 'user';

  const hitSlop = { top: 12, bottom: 12, left: 12, right: 12 };

  return (
    <View style={styles.bar}>
      <Pressable
        style={styles.tab}
        android_ripple={{ color: 'rgba(0,0,0,0.06)', borderless: false }}
        hitSlop={hitSlop}
        onPress={() => navigation.navigate('HomeRoot', { screen: 'HomeScreen' })}
      >
        <Icon
          name={isHomeActive ? 'home' : 'home-outline'}
          size={24}
          color={isHomeActive ? colors.primary : colors.textSecondary}
        />
        <Text style={[styles.label, { color: isHomeActive ? colors.primary : colors.textSecondary }]}>Home</Text>
      </Pressable>

      <Pressable
        style={styles.tab}
        android_ripple={{ color: 'rgba(0,0,0,0.06)', borderless: false }}
        hitSlop={hitSlop}
        onPress={() => navigation.navigate('AllDevotions')}
      >
        <Icon
          name={isCalendarActive ? 'calendar' : 'calendar-outline'}
          size={24}
          color={isCalendarActive ? colors.primary : colors.textSecondary}
        />
        <Text style={[styles.label, { color: isCalendarActive ? colors.primary : colors.textSecondary }]}>Devotions</Text>
      </Pressable>

      <Pressable
        style={styles.tab}
        android_ripple={{ color: 'rgba(0,0,0,0.06)', borderless: false }}
        hitSlop={hitSlop}
        onPress={() => navigation.navigate(isAuthenticated ? 'UserProfile' : 'Login')}
      >
        <Icon
          name={isUserActive ? 'person' : 'person-outline'}
          size={24}
          color={isUserActive ? colors.primary : colors.textSecondary}
        />
        <Text style={[styles.label, { color: isUserActive ? colors.primary : colors.textSecondary }]}>
          {isAuthenticated ? 'Profile' : 'Login'}
        </Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  bar: {
    height: BAR_HEIGHT,
    backgroundColor: colors.surface,
    borderTopWidth: 1,
    borderTopColor: colors.accent,
    shadowColor: colors.primary,
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 8,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  tab: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: mvs(6),
    paddingHorizontal: mvs(12),
  },
  label: {
    fontSize: 11,
    textAlign: 'center',
    width: 60,
    marginTop: mvs(8),
    fontFamily: 'DMSans-Regular',
  },
});

export default BottomBar;